import { render, staticRenderFns } from "./formCanvas.vue?vue&type=template&id=79615e84&scoped=true&"
import script from "./formCanvas.vue?vue&type=script&lang=js&"
export * from "./formCanvas.vue?vue&type=script&lang=js&"
import style0 from "./formCanvas.vue?vue&type=style&index=0&id=79615e84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79615e84",
  null
  
)

export default component.exports